import styled from "styled-components";

const DropDownList = styled.p`
    font-size: 14px;
    line-height: normal;
    color: #2f2f2f;
    padding: 11px 15px;
    border-bottom: 1px solid #ddd;

    &:hover {
        background: #ddd;
    }
    &:active {
        background: #ddd;
    }
`;
export default DropDownList;
